import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Check, ShieldCheck, Lock, Zap, CreditCard } from 'lucide-react';
export function OfferCards() {
  return <SectionWrapper id="pricing" data-id="element-170">
      <div className="text-center mb-12" data-id="element-171">
        <h2 className="text-4xl md:text-5xl font-serif font-bold text-burgundy mb-4" data-id="element-172">
          Elegí tu Pack Código Hijo:
        </h2>
        <p className="text-xl text-text-main/80 font-medium" data-id="element-173">
          Las dos opciones incluyen los 3 bonus completos
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12 items-stretch" data-id="element-174">
        {/* Card 1 - Premium (ahora primero) */}
        <div className="bg-card-bg rounded-3xl p-8 border-2 border-gold shadow-xl flex flex-col relative transform md:-translate-y-4" data-id="element-175">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-text-main px-6 py-1.5 rounded-full text-sm font-black tracking-wider shadow-md flex items-center gap-1 w-max" data-id="element-176">
            ⭐ MÁS ELEGIDO
          </div>

          <div className="absolute -top-3 -right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-lg shadow-sm transform rotate-12" data-id="element-177">
            AHORRÁS $33 USD
          </div>

          <div className="text-center mb-6 mt-4" data-id="element-178">
            <h3 className="text-2xl font-black text-burgundy mb-2 flex items-center justify-center gap-2" data-id="element-179">
              <span className="text-3xl" data-id="element-180">🏆</span> CÓDIGO HIJO + CRIANZA PRO
            </h3>
            <p className="text-sm font-medium text-text-main/80 bg-gold/20 p-3 rounded-xl" data-id="element-181">
              <strong className="block mb-1 text-base" data-id="element-182">
                6 tomos + 3 bonus + Módulo Crianza Pro
              </strong>
              (comunicación avanzada, manejo de crisis y plan de conexión anual)
            </p>
          </div>

          <div className="text-center mb-8" data-id="element-183">
            <p className="text-xl text-text-main/50 line-through font-bold mb-1" data-id="element-184">
              $47 USD
            </p>
            <p className="text-6xl font-black text-burgundy" data-id="element-185">
              $13.97 <span className="text-2xl" data-id="element-186">USD</span>
            </p>
          </div>

          <div className="mt-auto" data-id="element-187">
            <a href="https://pay.hotmart.com/H105289774B?checkoutMode=10" className="block w-full bg-burgundy text-white font-bold text-xl py-5 rounded-xl hover:bg-burgundy/90 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all mb-4 text-center" data-id="element-188">
              SÍ, QUIERO EL PACK COMPLETO →
            </a>
            <p className="text-center text-sm font-medium text-text-main/70 italic" data-id="element-189">
              La más elegida por mamás que quieren transformar el vínculo de
              raíz
            </p>
          </div>
        </div>

        {/* Card 2 - Standard (ahora segundo) */}
        <div className="bg-white rounded-3xl p-8 border border-dusty-rose/30 shadow-sm flex flex-col relative mt-4 md:mt-8" data-id="element-190">
          <div className="text-center mb-8" data-id="element-191">
            <h3 className="text-2xl font-black text-text-main mb-2 flex items-center justify-center gap-2" data-id="element-192">
              <span className="text-3xl" data-id="element-193">📘</span> CÓDIGO HIJO COMPLETO
            </h3>
            <p className="text-lg font-medium text-text-main/70" data-id="element-194">
              6 tomos + 3 bonus
            </p>
          </div>

          <div className="text-center mb-8" data-id="element-195">
            <p className="text-xl text-text-main/50 line-through font-bold mb-1" data-id="element-196">
              $27 USD
            </p>
            <p className="text-6xl font-black text-burgundy" data-id="element-197">
              $9.97 <span className="text-2xl" data-id="element-198">USD</span>
            </p>
          </div>

          <div className="mt-auto" data-id="element-199">
            <a href="https://pay.hotmart.com/S104936734A" className="block w-full bg-white text-burgundy border-2 border-burgundy font-bold text-lg py-4 rounded-xl hover:bg-burgundy/5 transition-colors text-center" data-id="element-200">
              QUIERO MI CÓDIGO HIJO →
            </a>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-text-main/70 font-medium bg-white/50 py-6 rounded-2xl border border-dusty-rose/10" data-id="element-201">
        <span className="flex items-center gap-2" data-id="element-202">
          <Lock size={18} className="text-gray-600" data-id="element-203" /> Pago seguro
        </span>
        <span className="flex items-center gap-2" data-id="element-204">
          <Zap size={18} className="text-yellow-500" data-id="element-205" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-2" data-id="element-206">
          <ShieldCheck size={18} className="text-green-600" data-id="element-207" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-2" data-id="element-208">
          <CreditCard size={18} className="text-blue-600" data-id="element-209" /> Todas las tarjetas
        </span>
      </div>
    </SectionWrapper>;
}